import React from "react";

export default function NoDataDischargeVin() {
  return (
    <>
      <div className="v-title chartbox" style={{marginTop:"22px"}}>
        <div className="chartHGT">
          <div className="alert alert-danger no_data">records not found</div>
          <div style={{ height: "115px" }} ></div>
        </div>
      </div>
    </>
  );
}